module.exports = __webpack_public_path__ + "static/media/lampadina.4ce47688.png";